'use strict';

import Api from "./Api";

export default class Catalog extends Api {

    static getList(page = 1, perPage = 10, sort = undefined) {
        const url = this.url + 'catalog/good-list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
            },
        });
    }

    static get(id) {
        const url = this.url + 'catalog/good-get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'catalog/good-add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'catalog/good-update';

        return this.getAxios().post(url, data);
    }

}
